// The Overview's severity counts (lib/overview.js casesBySeverity) and
// investigation cards (investigationsIn), kept in memory so a return to the
// page shows them at once while the Findings cases and investigations are
// read again. Each is kept until the time it is kept with: the range's
// for a while, the span before's (a fixed window) to the end of its hour.
// A triage decision ("origin-investigation-saved") or a change of sign-in
// drops them all, so a count never outlives what changed it.
import { getAuthContextEpoch, onAuthContextChange } from "./authTokenStore.js";

export const KEEP_MS = 15 * 60 * 1000;
export const MAX_KEPT = 8;
const kept = new Map();
const clear = () => kept.clear();
onAuthContextChange(clear);
globalThis.addEventListener?.("origin-investigation-saved", clear);

const keyOf = (key) => `${getAuthContextEpoch()}|${key}`;

/** The start of the hour after `ms`. */
export const endOfHour = (ms) => new Date(ms).setMinutes(60, 0, 0);

/** Keeps `value` ({ counts, clipped }) under `key` until `untilMs`. */
export function keepCounts(key, value, untilMs, nowMs = Date.now()) {
    if (untilMs <= nowMs) return;
    const k = keyOf(key);
    kept.delete(k);
    kept.set(k, { value, untilMs });
    while (kept.size > MAX_KEPT) kept.delete(kept.keys().next().value);
}

/** What is kept under `key`, or null where nothing is or it expired. */
export function keptCounts(key, nowMs = Date.now()) {
    const k = keyOf(key);
    const entry = kept.get(k);
    if (!entry) return null;
    if (nowMs >= entry.untilMs) { kept.delete(k); return null; }
    return entry.value;
}

export function _resetKeptCountsForTests() {
    kept.clear();
}
